import { RootState } from '../../types/redux/states/RootState';

export const getResellerId = ({ visitor }: RootState): number => visitor.resellerId;
